import React , { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import axios from "axios";

function Header() {

   const [services, setServices] = useState([]); // Store API Data

  // Fetch Services from API
  useEffect(() => {
    axios
      .get("https://dhk.deliveryxpressbd.com/Services/all_services_api")
      .then((response) => {
        setServices(response.data); // Store API response in state
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, []);

  return (
  
      <div className='header_section header_bg  fixed-top'>

            <div className="container-fluid"  >
               <nav className="navbar navbar-expand-lg navbar-light bg-light">
                  <a className="navbar-brand"href="/"><img src={`${process.env.PUBLIC_URL}/Assets/images/Logo.png`}/></a>
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                     <ul className="navbar-nav ml-auto">
                        <li className="nav-item active">
                           <a className="nav-link" href="/">Frontpage</a>
                        </li>
                        <li className="nav-item">
                           <a className="nav-link" href="/About">About Us</a>
                        </li>
                        <li class="nav-item dropdown">
                           <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                           Services
                           </a>
                           <div className="dropdown-menu">
                              {services.map((service) => (
                              <Link
                                 key={service.id}
                                 className="dropdown-item"
                                 to={`/Services/${service.id}`}
                              >
                                 {service.name}
                              </Link>
                              ))}
                           </div>
                        </li>
                        <li className="nav-item">
                           <a className="nav-link" href="/Quote">Quote Request</a>
                        </li>
                        <li className="nav-item">
                           <a className="nav-link" href="/Career">Career</a>
                        </li>
                     
                        <li className="nav-item">
                           <a className="nav-link" href="/Contact">Contact</a>
                        </li>
                     </ul>
                     <form className="form-inline my-2 my-lg-0">
                        <div className="login_bt">
                           <ul>
                           
                             <li class="active "><a href="tel:+358 40 053 2333"><i class="fa fa-phone phone-icon">  +358 40 053 2333 </i></a></li>
                           
                           </ul>
                        </div>
                     </form>
                  </div>
               </nav>
            </div>
      </div>

    
  )
}

export default Header